import { Component } from '@angular/core';

@Component({
    selector: 'pdf-alt-text-settings-dialog',
    templateUrl: './pdf-alt-text-settings-dialog.component.html',
    styleUrls: ['./pdf-alt-text-settings-dialog.component.css'],
    standalone: false
})
export class PdfAltTextSettingsDialogComponent {}
